
import {
  defineComponent, ref, watch,
} from 'vue';
import { Pagination,Select, } from 'ant-design-vue';
import ptzControl from '@/components/camera/ptzControl.vue';
import multiFrame from '@/components/camera/multiFrame.vue';
import CameraApi from '@/utils/camera';
import { cameraIp, streamPrefix, } from '@/configs/index';

const { Option, } = Select;

export default defineComponent({
  components: {
    ptzControl,
    multiFrame,
    Pagination,
    Select,
    Option,
  },
  props: {
    name: {
      type: String,
      default: '',
    },
  },
  setup (props, { emit, }) {
    // 当前选中通道
    const curChannel = ref<string>('all');
    // 分页
    const btnInfo = [{ value: 1, label: '1幅', }, { value: 4, label: '4幅', },];

    // 是否为操作页面
    const isSelected = ref<boolean>(false);
    // 分页
    const pageSize = ref<number>(1);
    const currentPage = ref<number>(1);
    // 当前显示的摄像头信息
    const showVideos = ref<any[]>([]);
    const urls = ref<string[]>([]);
    // 所有摄像头信息
    const videos = ref<any[]>([]);

    // 切换按钮
    const changeNum = (val: any): void => {
      pageSize.value = val;
      currentPage.value = 1;
      const startIndex = 0;
      const endIndex = val;

      // 展示所需摄像头数组
      showVideos.value = videos.value.slice(startIndex, endIndex);
    };

    // 翻页
    const onChange = (currentPageNum: number, currentPageSize?: number): void => {
      currentPage.value = currentPageNum;
      const startIndex = (currentPageNum - 1) * pageSize.value;
      const endIndex = currentPageNum * pageSize.value;

      isSelected.value = false;

      // 展示所需摄像头数组
      showVideos.value = videos.value.slice(startIndex, endIndex);
    };

    // 通道切换
    const selectChange = (val: string|number) => {
      if (val === 'all') {
        isSelected.value = false;
        changeNum(1);
      } else {
        isSelected.value = true;
        pageSize.value = 1;

        showVideos.value = [videos.value[val],] || [];
      }
    };

    const getToken = () => CameraApi.getToken();

    // 异步请求接口
    const asyncWorker = (item: any, quality: 0 | 1) => new Promise((resolve) => {
      const urlType = quality === 0 ? 'url' : 'secUrl';

      if (item[urlType]) {
        resolve(item[urlType]);
      } else {
        const { deviceId, channelId, } = item;
        const params = {
          // isSubStream
        };

        CameraApi.getUrl(deviceId, channelId, params)
          .then((res: any) => {
            const flvUrl = res?.flv || '';
            // 正则替换主机名,走代理
            const url = flvUrl.replace(/(http|https):\/\/([\w.]+)(:\d+)?/, streamPrefix);

            // eslint-disable-next-line no-param-reassign
            item[urlType] = url;

            resolve(url);
          })
          .catch(() => {
            resolve('');
          });
      }
    });

    // 接口请求获取视频urls
    const reqUrls = (list: any[], num: number) => {
      if (!list || list.length === 0) {
        return Promise.resolve([]);
      }
      const tempList = list.map((item: any): Promise<any> => asyncWorker(item, 0));

      return Promise.all(tempList);
    };

    // 设置url
    const setUrls = (list: any[], num: number) => {
      reqUrls(list, num).then((res) => {
        const len = res?.length || 0;
        let tmpLen = num - len;
        const tmpUrls = res || [];

        // 补全urls,保证1、4、9画面
        while (tmpLen > 0) {
          tmpUrls.push('');
          tmpLen--;
        }
        urls.value = tmpUrls;
      });
    };

    // 请求通道列表
    const getChannelByName = (name: string) => {
      const params = {
        deviceName: name,
      };

      return CameraApi.getAllChannelList(params);
    };

    const init = (name: string) => {
      getToken()
        .then(() => getChannelByName(name))
        .then((res: any) => {
          videos.value = res || [];
          showVideos.value = videos.value.slice(0, 1) || [];
        });
    };
    // 父组件赋值
    const setParamData = (val:any) => {
      pageSize.value = 1;
      currentPage.value = 1;
      videos.value = [];
      showVideos.value = [];
      curChannel.value = 'all';
      isSelected.value = false;
      init(val || '');
    };

    watch(showVideos, (val) => {
      setUrls(val, pageSize.value);
    });

    return {
      selectChange,
      changeNum,
      onChange,
      setParamData,
      curChannel,
      urls,
      pageSize,
      currentPage,
      btnInfo,
      videos,
      isSelected,
      showVideos,
    };
  },
});
